/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Goal_ReachedInputs */

const en_goal_reached = /** @type {(inputs: Goal_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goal Reached`)
};

const ar_goal_reached = /** @type {(inputs: Goal_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم تحقيق الهدف`)
};

const de_goal_reached = /** @type {(inputs: Goal_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziel erreicht`)
};

const es_goal_reached = /** @type {(inputs: Goal_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objetivo alcanzado`)
};

const fr_goal_reached = /** @type {(inputs: Goal_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objectif atteint`)
};

const it_goal_reached = /** @type {(inputs: Goal_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obiettivo raggiunto`)
};

const ja_goal_reached = /** @type {(inputs: Goal_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目標達成`)
};

const ko_goal_reached = /** @type {(inputs: Goal_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`목표 달성`)
};

const pt_br_goal_reached = /** @type {(inputs: Goal_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta atingida`)
};

const ru_goal_reached = /** @type {(inputs: Goal_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цель достигнута`)
};

const th_goal_reached = /** @type {(inputs: Goal_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บรรลุเป้าหมายแล้ว`)
};

const tr_goal_reached = /** @type {(inputs: Goal_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hedefe Ulaşıldı`)
};

const zh_cn_goal_reached = /** @type {(inputs: Goal_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已达标`)
};

const zh_tw_goal_reached = /** @type {(inputs: Goal_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已達標`)
};

/**
* | output |
* | --- |
* | "Goal Reached" |
*
* @param {Goal_ReachedInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const goal_reached = /** @type {((inputs?: Goal_ReachedInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Goal_ReachedInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_goal_reached(inputs)
	if (locale === "ar") return ar_goal_reached(inputs)
	if (locale === "de") return de_goal_reached(inputs)
	if (locale === "es") return es_goal_reached(inputs)
	if (locale === "fr") return fr_goal_reached(inputs)
	if (locale === "it") return it_goal_reached(inputs)
	if (locale === "ja") return ja_goal_reached(inputs)
	if (locale === "ko") return ko_goal_reached(inputs)
	if (locale === "pt_br") return pt_br_goal_reached(inputs)
	if (locale === "ru") return ru_goal_reached(inputs)
	if (locale === "th") return th_goal_reached(inputs)
	if (locale === "tr") return tr_goal_reached(inputs)
	if (locale === "zh_cn") return zh_cn_goal_reached(inputs)
	return zh_tw_goal_reached(inputs)
});